import React from "react";
import { ArrowDownRight, ArrowUpRight, Info } from "lucide-react";

const money = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(Number(value) || 0);

const FinancialCard = ({
  title,
  helper,
  amount,
  growth,
  currentAmount,
  overdueAmount,
  currentCount,
  overdueCount,
  itemLabel,
  variant,
}) => {
  const total = Math.max(Number(currentAmount) + Number(overdueAmount), 1);
  const currentWidth = Math.max((Number(currentAmount) / total) * 100, overdueAmount ? 0 : 100);
  const overdueWidth = (Number(overdueAmount) / total) * 100;
  const isPositive = Number(growth) >= 0;
  const TrendIcon = isPositive ? ArrowUpRight : ArrowDownRight;

  return (
    <section className="zarp-financial-card">
      <div className="zarp-card-title-row">
        <div>
          <h2>
            {title}
            <Info size={15} />
          </h2>
          <strong>{money(amount)}</strong>
          <p>{helper}</p>
        </div>
        <div className={`zarp-growth-badge ${variant}`}>
          <TrendIcon size={14} />
          {Math.abs(Number(growth) || 0)}%
          <small>vs last 30 days</small>
        </div>
      </div>

      <div className="zarp-progress">
        <span className="is-current" style={{ width: `${currentWidth}%` }} />
        <span className="is-overdue" style={{ width: `${overdueWidth}%` }} />
      </div>

      <div className="zarp-financial-split">
        <div>
          <span>Current</span>
          <strong className="is-current">{money(currentAmount)}</strong>
          <small>{currentCount} {itemLabel}</small>
        </div>
        <div>
          <span>Overdue</span>
          <strong className="is-overdue">{money(overdueAmount)}</strong>
          <small>{overdueCount} {itemLabel}</small>
        </div>
      </div>
    </section>
  );
};

const FinancialSummary = ({ data = {} }) => (
  <div className="zarp-financial-grid">
    <FinancialCard
      title="Total Receivables"
      helper="Total Unpaid Invoices"
      amount={data.totalReceivables}
      growth={data.receivablesGrowth}
      currentAmount={data.receivablesCurrent}
      overdueAmount={data.receivablesOverdue}
      currentCount={data.currentInvoices}
      overdueCount={data.overdueInvoices}
      itemLabel="invoices"
      variant="success"
    />
    <FinancialCard
      title="Total Payables"
      helper="Total Unpaid Bills"
      amount={data.totalPayables}
      growth={data.payablesGrowth}
      currentAmount={data.payablesCurrent}
      overdueAmount={data.payablesOverdue}
      currentCount={data.currentBills}
      overdueCount={data.overdueBills}
      itemLabel="bills"
      variant="success"
    />
  </div>
);

export default FinancialSummary;
